import { FaqCategory } from "@/lib/types/faqs.ts";
import * as S from "./styles.ts";
import { UniversalLink } from "@template/components";

interface IFaqMenuProps {
  categories: FaqCategory[];
  categoryUrlKey: string;
}

export const FaqMenu = ({ categories, categoryUrlKey }: IFaqMenuProps) => {
  return (
    <S.MenuContainer>
      <S.Title>Categories</S.Title>
      <S.MenuItemsContainer>
        <S.MenuItems>
          {categories.map((category, index) => (
            <S.MenuItem
              key={index}
              $active={category.url_key === categoryUrlKey}
            >
              <UniversalLink
                href={`/faq/${category.url_key}`}
                scroll={false}
                title={`Learn more about ${category.category_name}`}
              >
                {category.category_name}
              </UniversalLink>
            </S.MenuItem>
          ))}
        </S.MenuItems>
      </S.MenuItemsContainer>
    </S.MenuContainer>
  );
};
